import { useState } from "react";
import { GripVertical, Play, X } from "lucide-react";
import { Cover } from "@/components/Cover";
import { usePlayer } from "@/context/PlayerContext";

/* Next few songs; drag rows to change the order (not in shuffle). Click a row to jump to it. */
export const QueuePeek = ({ onOpenQueue }) => {
  const p = usePlayer();
  const [drag, setDrag] = useState(null); // { from, over }
  const canDrag = !p.shuffle && p.upcoming.length > 1;
  const drop = (toIdx) => { if (drag && drag.from !== toIdx) p.moveInQueue(drag.from, toIdx); setDrag(null); };
  return (
    <div data-testid="queue-peek" data-dragging={drag ? "1" : "0"}>
      <p className="px-2 pb-1.5 pt-1 text-[9px] font-semibold uppercase tracking-[0.18em] text-zinc-400">{p.shuffle ? "Up next · shuffled" : "Up next"}{canDrag && <span className="ml-2 normal-case tracking-normal text-zinc-300">drag to reorder</span>}</p>
      <ul className="flex flex-col">
        {p.upcoming.map(({ track: u, index: i }, k) => {
          const over = drag && drag.over === i && drag.from !== i;
          return (
            <li key={`${u.id}-${i}`} draggable={canDrag}
              onDragStart={(e) => { e.dataTransfer.effectAllowed = "move"; setDrag({ from: i, over: i }); }}
              onDragOver={(e) => { if (!drag) return; e.preventDefault(); e.dataTransfer.dropEffect = "move"; if (drag.over !== i) setDrag({ ...drag, over: i }); }}
              onDrop={(e) => { e.preventDefault(); drop(i); }} onDragEnd={() => setDrag(null)}
              data-testid={`queue-peek-row-${k}`} data-index={i}
              className={`group/row relative rounded-lg transition-[background-color,box-shadow] ${over ? (drag.from < i ? "shadow-[0_2px_0_0_#18181b]" : "shadow-[0_-2px_0_0_#18181b]") : ""} ${drag?.from === i ? "opacity-40" : ""}`}>
              <button onClick={() => p.playAt(i)} data-testid={`queue-peek-${k}`} title="Play now"
                className="group flex w-full items-center gap-2 rounded-lg px-2 py-1.5 pr-9 text-left transition-colors hover:bg-zinc-100">
                {canDrag ? <GripVertical size={13} className="shrink-0 cursor-grab text-zinc-300 active:cursor-grabbing" data-testid={`queue-peek-grip-${k}`} />
                  : <span className="w-3 shrink-0 text-center font-mono text-[10px] text-zinc-400">{k + 1}</span>}
                <Cover albumId={u.album_id} className="h-9 w-9 shrink-0 shadow-sm" rounded="rounded" iconSize={14} />
                <span className="flex min-w-0 flex-1 flex-col">
                  <span className="truncate text-xs font-medium text-zinc-900">{u.title}</span>
                  <span className="truncate text-[11px] text-zinc-500">{u.artist}</span>
                </span>
                <Play size={12} fill="currentColor" className="shrink-0 text-zinc-300 transition-colors group-hover:text-zinc-900" />
              </button>
              <button onClick={() => p.removeAt(i)} data-testid={`queue-peek-remove-${k}`} title="Remove from queue" aria-label="Remove from queue"
                className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-zinc-300 opacity-0 transition-[opacity,color] hover:text-rose-600 group-hover/row:opacity-100 focus-visible:opacity-100">
                <X size={12} />
              </button>
            </li>
          );
        })}
      </ul>
      {p.shuffle && <p className="px-2 pb-1 pt-1.5 text-[11px] text-zinc-400">Then more songs in random order.</p>}
      <button onClick={onOpenQueue} data-testid="queue-peek-open" className="mt-1 w-full rounded-lg px-2 py-1.5 text-left text-[11px] text-zinc-500 transition-colors hover:bg-zinc-100 hover:text-zinc-900">Open full queue →</button>
    </div>
  );
};
